import { isNotEmptyString, isObject } from "@pineapplelab/util";
import { FBase } from "./FBase";
import { RoleEnum } from "../enums/role.enum";
import { Timestamp } from "firebase/firestore";
import { StatusEnum } from "../enums/status.enum";
import { AssignedCategory } from "./assignedCategory";
export class User extends FBase {

	username: string = null;
	isAdmin: boolean = null;
	email: string = null;
	role: RoleEnum = null;
	language: string = null;
	expirationDate: Timestamp = null;
	status: StatusEnum = StatusEnum.INACTIVE;
	name: string = null;
	client: string = null;
	lastName: string = null;
	instructors: string[] = [];

	__expirationDate: Date = null;
	__assignedCategories: AssignedCategory[] = [];
	__previouslyAssigned: boolean = false;

	canUpdate(): boolean {
		return isNotEmptyString(this.name) && isNotEmptyString(this.lastName);
	}

	constructor(json?: { [key: string]: any }) {
		super();
		if (isObject(json)) {
			this.fromJson(json);
		}
	}
}
export namespace User {

	export const PATH = 'users';

}
